<template>
  <div>

    <div class="row">

      <div class="col-3 my-3">
        <label for=""> Poid T</label>
        <input type="text" v-model="delivery.tareWeight" class="form-control">
      </div>

      <div class="col-3 my-3">
        <label for=""> Poid B </label>
        <input type="text" v-model="delivery.grossWeight" class="form-control">
      </div>

      <div class="col-3 my-3">
        <label for="">Chauffeur</label>
        <vue-select :options="employees.filter(p => p.fonction == 'Chauffeur')" v-model="delivery.deliveredBy_reference"
          labelColumn="fullName" valueColumn="reference" />
      </div>

      <div class="col-3 my-3">
        <label for="">Entreé de chargement</label>
        <input type="datetime-local" v-model="delivery.startChargeDatetime" class="form-control">
      </div>

      <div class="col-3 my-3">
        <label for="">Sortie de chargement</label>
        <input type="datetime-local" v-model="delivery.deliveryDateTime" class="form-control">
      </div>



      <div class="col-3 my-3">
        <label for="">Véhicule</label>
        <vue-select :options="vehicles" v-model="delivery.deliveryVehicle_reference" labelColumn="fullName"
          valueColumn="reference" />
      </div>

      <div class="col-12 my-3">
        <label for="">Remarque</label>
        <textarea class="form-control" v-model="delivery.remark"></textarea>
      </div>
    </div>


    <br />


    <button class="btn btn-success" @click="save(delivery)">
      <i class="bi bi-check-square-fill"></i> Enregistrer
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      reference: this.$route.params.reference,
      accept: false,
      actionButtons: [
        // {
        //   label: "Modifier les elements",
        //   class: "btn btn-outline-success",
        //   icon: "bi bi-check2-square",
        //   action: () => this.$userRole != 'Magasinier' ? this.$router.push({ name: 'deliveries-edit', params: { reference: this.reference } }) : '',
        // },
      ]
    };
  },
  computed: {
    ...mapGetters("delivery", {

      delivery: "getDelivery",
    }),
    ...mapGetters("employee", {
      employees: "getAll",
    }),

    ...mapGetters("vehicle", {
      vehicles: "getVehicles",
    }),
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("delivery/update", data);
    },
    async refresh() {
      await this.$store.dispatch("employee/getAll");
      await this.$store.dispatch("vehicle/getAll");
      await this.$store.dispatch("delivery/show", this.$route.params.reference);
    },


  },
  async mounted() {
    await this.$store.dispatch("employee/getAll");
    await this.$store.dispatch("vehicle/getAll");
    await this.$store.dispatch("delivery/show", this.$route.params.reference);
  },

};
</script>
